const showRegistrationDialog = () => {
  const dialog = document.getElementById('registration-modal') as HTMLDialogElement | null;

  if (!dialog) {
    return;
  }
  dialog.showModal();
  dialog.addEventListener('click', (event: MouseEvent) => {
    const rect = dialog.getBoundingClientRect();
    const isInDialog =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;
    if (!isInDialog) {
      dialog.close();
    }
  });
};

export const closeRegistrationDialog = () => {
  const dialog = document.getElementById('registration-modal') as HTMLDialogElement | null;
  if (dialog) {
    dialog.close();
  }
};

export const registerRegistrationButtons = () => {
  const buttons = document.querySelectorAll('button.registration-button');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      showRegistrationDialog();
    });
  });
  const closeButtons = document.querySelectorAll('button.close-registration-modal');
  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      closeRegistrationDialog();
    });
  });
};

export default showRegistrationDialog;
